import angular from 'angular';
import MenuItemDirective from './menu-item.directive';

let MenuItemModule = angular.module('home.menuItem', [])
  .directive('menuItem', MenuItemDirective);

export default MenuItemModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/home/menu/menu-item/menu-item.js
 **/